// Only using a type. Still working on module boudary improvements.

import { AllFlags } from '@mode/shared/contract-common';
import { Operation } from 'diffj/dist/lib/jsonPatch';

import { ErrorEvent } from '@mode/shared/contract-common';
import { EmbedBuilderActions } from '../builder/embed-builder.actions';

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RpcMessages {
  export enum MessageTypes {
    InitReport = 'rpc.InitReport',
    InitCellResults = 'rpc.InitCellResults',
    UpdateState = 'rpc.updateState',
  }

  export class EmptyResponse {
    constructor(public readonly ok: boolean, public readonly error?: string) {}
  }

  export class InitReport {
    readonly type = MessageTypes.InitReport;

    constructor(
      public readonly layout: string,
      public readonly baseThemeHref: string,
      public readonly customSource: string,
      public readonly launchDarklyFlags: AllFlags,
      public readonly isCaptureMode?: boolean,
      public readonly embed_id?: string
    ) {}
  }

  export class InitCellResults {
    readonly type = MessageTypes.InitCellResults;

    constructor(public readonly content: string) {}
  }

  export class UpdateState {
    readonly type = MessageTypes.UpdateState;

    constructor(public readonly diff: Operation[]) {}
  }
}

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace EmitMessages {
  export enum MessageTypes {
    Action = 'emit.action',
    Ready = 'emit.ready',
    UpdateState = 'emit.updateState',
    Error = 'emit.error',
  }

  export class UpdateState {
    readonly type = MessageTypes.UpdateState;

    constructor(public readonly diff: any) {}
  }

  export class Action {
    readonly type = MessageTypes.Action;

    constructor(public readonly action: EmbedBuilderActions.Actions) {}
  }

  export class Ready {
    readonly type = MessageTypes.Ready;
    constructor(public readonly id: string) {}
  }

  export class Error {
    readonly type = MessageTypes.Error;

    constructor(public readonly errorEvent: ErrorEvent) {}
  }
}
